import { cssInterop } from 'nativewind';
import { useContext } from 'react';
import { Platform, Text as RNText, TextStyle } from 'react-native';
import { cn } from '../../lib/utils';
import { mapFontWeights } from './helper';
import { TextAncestorContext } from './TextAncestorContext';

export interface TextProps {
  className?: string;
  style?: TextStyle;
  children: React.ReactNode;
  as?: React.ElementType<any>;
}

export const Text =
  Platform.OS == 'web'
    ? TextWeb
    : cssInterop(TextNative, {
        className: {
          target: 'style',
        },
      });

function TextWeb({ className, as, children, style }: TextProps) {
  // This TextAncestorContext logic is mostly copied from the react native web code. The reason why i am not using that
  // directly is to have more control over the actual html elements being used
  // https://github.com/necolas/react-native-web/blob/fcbe2d1e9225282671e39f9f639e2cb04c7e1e65/packages/react-native-web/src/exports/Text/index.js
  const hasTextAncestor = useContext(TextAncestorContext);

  const textStyle = {
    ...style,
    // HACK: Line height is treated as a unitless value on web and just passing in a number will be treated as
    // a multiple of the font size instead of pixesls. This is different behaviour from react native.
    // As a workaround, we just add 'px' to the number
    // https://github.com/facebook/react/issues/5678
    lineHeight: style?.lineHeight ? style.lineHeight + 'px' : undefined,
  };

  const Component = as ?? (hasTextAncestor ? 'span' : 'p');
  const element = (
    <Component className={cn('text-white', className)} style={textStyle}>
      {children}
    </Component>
  );

  return hasTextAncestor ? (
    element
  ) : (
    <TextAncestorContext.Provider value={true}>
      {element}
    </TextAncestorContext.Provider>
  );
}

function TextNative({ className, style, as, children }: TextProps) {
  style = {
    ...style,
    // Only one font for now
    fontFamily: 'Bozon',
  };

  // This replaces font family and weight in a way that works on all platforms (see code)
  style = mapFontWeights(style);
  return (
    <RNText style={style} className={cn('text-white', className)}>
      {children}
    </RNText>
  );
}
